<template>
  <div class="form-page">
    <div class="form-page__header">
      <h2 class="form-page__title">Datenschutzerklärung</h2>
      <p class="form-page__subtitle">Informationen zur Verarbeitung Ihrer personenbezogenen Daten</p>
    </div>

    <div class="form-section">
      <div class="info-box info-box--blue">
        <span class="info-box__icon">🔒</span>
        <div>
          <strong>Datenschutz der Senatsverwaltung für Kultur und Gesellschaftlichen Zusammenhalt</strong>
          <p>Ihre personenbezogenen Daten werden gemäß den geltenden datenschutzrechtlichen Bestimmungen verarbeitet.</p>
        </div>
      </div>

      <div class="legal-block">
        <h3 class="legal-block__title">1. Verantwortliche Stelle</h3>
        <p>Senatsverwaltung für Kultur und Gesellschaftlichen Zusammenhalt<br/>
        Brunnenstraße 188–190, 10119 Berlin<br/>
        Telefon: (030) 90228-0<br/>
        E-Mail: poststelle@senkultur.berlin.de</p>
      </div>

      <div class="legal-block">
        <h3 class="legal-block__title">2. Zweck der Datenverarbeitung</h3>
        <p>Die erhobenen Daten werden ausschließlich zur Bearbeitung Ihres Antrags auf ein Arbeitsstipendium für deutschsprachige Literatur verwendet. Die Rechtsgrundlage bildet Art. 6 Abs. 1 lit. e DSGVO in Verbindung mit dem Berliner Datenschutzgesetz (BlnDSG).</p>
      </div>

      <div class="legal-block">
        <h3 class="legal-block__title">3. Speicherdauer</h3>
        <p>Ihre Daten werden für die Dauer des Bewerbungsverfahrens gespeichert. Nach Abschluss des Verfahrens werden die Daten entsprechend der gesetzlichen Aufbewahrungsfristen archiviert und anschließend gelöscht.</p>
      </div>

      <div class="legal-block">
        <h3 class="legal-block__title">4. Ihre Rechte</h3>
        <p>Sie haben das Recht auf Auskunft, Berichtigung, Einschränkung der Verarbeitung und Widerspruch. Darüber hinaus haben Sie das Recht, sich bei der Berliner Beauftragten für Datenschutz und Informationsfreiheit zu beschweren.</p>
        <p class="legal-contact">Berliner Beauftragte für Datenschutz und Informationsfreiheit<br/>
        Friedrichstr. 219, 10969 Berlin | datenschutz@datenschutz-berlin.de</p>
      </div>

      <div class="legal-block">
        <h3 class="legal-block__title">5. Datenschutzbeauftragter</h3>
        <p>Den behördlichen Datenschutzbeauftragten der Senatsverwaltung für Kultur erreichen Sie unter: datenschutz@senkultur.berlin.de</p>
      </div>
    </div>

    <div class="info-box info-box--green">
      <span class="info-box__icon">✅</span>
      <div>
        <strong>Indem Sie auf „Weiter" klicken, bestätigen Sie</strong>
        <p>dass Sie die Datenschutzerklärung zur Kenntnis genommen haben.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default { name: 'LitStep2' };
</script>

<style scoped src="../form.css"></style>
